const useCoaching = (): boolean => config.hasUpskillingCoaching

export default useCoaching
